// components/CropModal.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';

const getCroppedImg = (imageSrc, croppedAreaPixels, type = 'photo') => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = imageSrc;

        image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // ✅ FIXED OUTPUT SIZE
            const outputWidth = type === 'photo' ? 300 : 300;
            const outputHeight = type === 'photo' ? 400 : 100;

            canvas.width = outputWidth;
            canvas.height = outputHeight;

            ctx.drawImage(
                image,
                croppedAreaPixels.x,
                croppedAreaPixels.y,
                croppedAreaPixels.width,
                croppedAreaPixels.height,
                0,
                0,
                outputWidth,
                outputHeight
            );

            canvas.toBlob((blob) => {
                if (!blob) return reject(new Error('Canvas is empty'));
                const file = new File([blob], 'cropped.jpg', { type: 'image/jpeg' });
                resolve(file);
            }, 'image/jpeg', 0.9);
        };

        image.onerror = () => reject(new Error('Failed to load image'));
    });
};

const CropModal = ({ file, onClose, onCropComplete, aspect = 1 }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageSrc(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }, [file]);

    const handleCropComplete = useCallback((_, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

    const handleCropAndUse = async () => {
        try {
            const croppedImage = await getCroppedImg(
                imageSrc,
                croppedAreaPixels,
                aspect === 6 / 7 ? 'photo' : 'sign'
            );
            onCropComplete(croppedImage);
            onClose();
        } catch (err) {
            console.error('Crop failed', err);
        }
    };

    if (!imageSrc) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: '#00000099' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Crop Image</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body" style={{ height: '400px', position: 'relative' }}>
                        <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={aspect}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={handleCropComplete}
                        />
                    </div>
                    <div className="modal-footer">
                        <input
                            type="range"
                            min={1}
                            max={5}
                            step={0.1}
                            value={zoom}
                            onChange={(e) => setZoom(e.target.value)}
                            className="form-range w-50"
                        />
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleCropAndUse}>
                            Crop & Use
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CropModal;
